export const UMB_PROPERTY_EDITOR_SCHEMA_ALIAS_DEFAULT = 'Umbraco.Label';
export const UMB_MISSING_PROPERTY_EDITOR_UI_ALIAS = 'Umb.PropertyEditorUi.Missing';
export const UMB_MISSING_PROPERTY_EDITOR_UI_UI_ALIAS = 'Umb.PropertyEditorUi.MissingUi';
